import React, { useEffect, useState } from 'react';
import { Wrapper } from './ActiveTopic.styled';
import { useSelector, useDispatch } from 'react-redux';
import Sentiments from './Sentiments/SentimentsTab';
import Insights from './Insights/InsightsTab';
import ReviewsTab from './ReviewsTab/ReviewsTab';
import Overview from './OverViewTab/OverView';
import ClusterAnalysisTab from './ClusterAnalysisTab/ClusterAnalysisTab';
import CustomAnalysisTab from './CustomAnalysisTab/CustomAnalysisTab';
import GenerateAnalysis from '../../components/Generate Analysis/GenerateAnalysis';
import {
  fetchCreatedTopic,
  createNewTopic,
  activeTopicList,
  setPopUpActive,
} from '../../store/redux/slices/topicSlice';
import { useNavigate } from 'react-router-dom';
import OverviewTabInsta from './OverViewTab/OverviewTabInsta';
import OverviewTabFb from './OverViewTab/OverviewTabFb';
import OverviewNews from './OverViewTab/OverviewNews';
import FilterPopup from '../../Common/FilterPopup/FilterPopup';
import ReportHeaderFile from '../../components/HeaderFileReport/ReportHeaderFile';
import TabHeadingComp from '../../Common/TabHeading/TabHeading';
import FilterWithDate from '../../Common/FilterWithDate/FilterWithDate';
import useTopicData from './CustomHook/ActiveTopicHook';
import XYZComponent from './XYZ/XYZ';
import Lottie from 'lottie-react';
import Loader from '../../assests/animation/Loader2.json';
import styled from 'styled-components';
import OverviewLinkedIn from './OverViewTab/OverviewLinkedIn';
import { use } from 'react';

const LoaderDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80vh;
    & > svg {
    
    width: 300px;
    height: 300px;
    }
}
`;
const ActiveTopic = ({ job_id }) => {
  const dispatch = useDispatch();
  const [shareOption, setShareOption] = useState(false);
  const navigate = useNavigate();
  // const { topicPreviewData } = useSelector((state) => state.topicBuilder) || {};
  const { personalDetailsData } =
    useSelector((state) => state.tenantSetting) || {};
  const {
    loader,
    activeTab,
    searchQuery,
    topicPreviewData,
    filterFlag,
    filterOption,
    selectedOption,
    filteredData,
    resetFlag,
    applyFilter,
    orgFilterOption,
    orgView,
    startDate,
    endDate,
    showSave,
    openDropdown,
    fetchedData,
    view,
    setView,
    setFilterOption,
    setSelectedOption,
    setOpenDropdown,
    handleTabClick,
    handleFilter,
    handleClosePopup,
    handleApply,
    handleFilterChange,
    handleCancel,
    handleReset,
    dateHandler,
    dateSubmit,
    updateSearchQuery,
    clearFilters,
  } = useTopicData(job_id); // Using the custom hook
  const obj_tabs = [
    {
      name: 'Overviews',
      value: 'Overviews',
    },
    {
      name: 'Reach',
      value: 'Reach',
    },
    {
      name: 'Sentiments',
      value: 'Sentiments',
    },

    {
      name: 'Insights',
      value: 'Insights',
    },
    {
      name: 'PerceptMap',
      value: 'Cluster_Analysis',
    },
    // {
    //   name: 'AskIQ',
    //   value: 'Custom_Analysis',
    // },
  ];

  const overView_tab = fetchedData?.overview_tab || {};
  const sentiments_tab = fetchedData?.sentiments_tab || {};
  const reach_tab = fetchedData?.reach_tab || {};
  const insights_tab = fetchedData?.insights_tab || {};
  const clusterAnalysis_tab = fetchedData?.cluster_analysis_tab || {};
  const popUpActive = useSelector((state) => state.topicBuilder.popUpActive);
  console.log(popUpActive,'popUpActive');
  
  const handleShareClick = () => {
    
    dispatch(setPopUpActive(true))
    setShareOption(!shareOption);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overViewTab':
        return topicPreviewData?.channel === 'news' ? (
          <OverviewNews
            overview_tab={overView_tab}
            startDate={startDate}
            filteredStartDate={startDate}
            filteredEndDate={endDate}
            endDate={endDate}
            filterOption={orgFilterOption}
            filteredData={filteredData?.data?.overview_tab}
            resetFlag={resetFlag}
            view={orgView}
            formatValue={formatValue}
            handleTabClick={(data) => {
              handleTabClick(data);
            }}
            job_id={job_id}
          />
        ) : topicPreviewData?.channel === 'twitter' ? (
          <Overview
            overview_tab={overView_tab}
            startDate={startDate}
            filteredStartDate={startDate}
            job_id={job_id}
            preview_uuid={topicPreviewData?.preview_uuid}
            filteredEndDate={endDate}
            endDate={endDate}
            filterOption={orgFilterOption}
            filteredData={filteredData?.data?.overview_tab}
            resetFlag={resetFlag}
            view={orgView}
            handleTabClick={(data) => {
              handleTabClick(data);
            }}
            channel={topicPreviewData?.channel}
            formatValue={formatValue}
          />
        ) : topicPreviewData?.channel === 'facebook' ||
          topicPreviewData?.channel === 'youtube' ? (
          <OverviewTabFb
            overview_tab={overView_tab}
            startDate={startDate}
            filteredStartDate={startDate}
            filteredEndDate={endDate}
            endDate={endDate}
            filterOption={orgFilterOption}
            job_id={job_id}
            channel={topicPreviewData?.channel}
            preview_uuid={topicPreviewData?.preview_uuid}
            filteredData={filteredData?.data?.overview_tab}
            resetFlag={resetFlag}
            view={orgView}
            formatValue={formatValue}
            handleTabClick={(data) => {
              handleTabClick(data);
            }}
            search_type={
              topicPreviewData?.search_type ||
              topicPreviewData?.youtube_search_type ||
              ''
            }
          />
        ) : (
          <OverviewTabInsta
            overview_tab={overView_tab}
            startDate={startDate}
            filteredStartDate={startDate}
            filteredEndDate={endDate}
            endDate={endDate}
            job_id={job_id}
            preview_uuid={topicPreviewData?.preview_uuid}
            filterOption={orgFilterOption}
            filteredData={filteredData?.data?.overview_tab}
            resetFlag={resetFlag}
            view={orgView}
            formatValue={formatValue}
            channel={topicPreviewData?.channel}
            handleTabClick={(data) => {
              handleTabClick(data);
            }}
          />
        );
      case 'sentimentsTab':
        return (
          <Sentiments
            sentiments_tab={sentiments_tab}
            startDate={startDate}
            endDate={endDate}
            filteredStartDate={startDate}
            filteredEndDate={endDate}
            filterOption={orgFilterOption}
            resetFlag={resetFlag}
            filteredData={filteredData?.data?.sentiments_tab}
            view={orgView}
            channel={topicPreviewData?.channel}
            job_id={job_id}
            handleTabClick={(data) => {
              handleTabClick(data);
            }}
            formatValue={formatValue}
            is_news={topicPreviewData?.channel === 'news' ? true : false}
          />
        );
      case 'Reach':
        return (
          <XYZComponent
            xyz={reach_tab}
            startDate={startDate}
            endDate={endDate}
            filteredStartDate={startDate}
            filteredEndDate={endDate}
            filterOption={orgFilterOption}
            filteredData={filteredData?.data?.reach_tab}
            search_type={
              topicPreviewData?.search_type ||
              topicPreviewData?.youtube_search_type ||
              ''
            }
            view={orgView}
            resetFlag={resetFlag}
            job_id={job_id}
            handleTabClick={(data) => {
              handleTabClick(data);
            }}
            channel={topicPreviewData?.channel}
            formatValue={formatValue}
            is_news={topicPreviewData?.channel === 'news'}
            showSummaryDownload={topicPreviewData?.preview_uuid ? false : true}
          />
        );

      case 'insightTab':
        return (
          <Insights
            insights_data={insights_tab}
            startDate={startDate}
            endDate={endDate}
            job_id={job_id}
            handleTabClick={(data) => {
              handleTabClick(data);
              
              dispatch(setPopUpActive(true))
            }}
            filteredStartDate={startDate}
            filteredEndDate={endDate}
            filterOption={orgFilterOption}
            filteredData={filteredData?.data?.insights_tab}
            search_type={topicPreviewData?.search_type || ''}
            view={orgView}
            resetFlag={resetFlag}
            channel={topicPreviewData?.channel}
            formatValue={formatValue}
            is_news={topicPreviewData?.channel === 'news' ? true : false}
          />
        );
      case 'clusterAnalysis':
        return (
          <ClusterAnalysisTab
            cluster_analysis={clusterAnalysis_tab}
            startDate={startDate}
            endDate={endDate}
            job_id={job_id}
            handleTabClick={(data) => {
              handleTabClick(data);
            }}
            filteredData={filteredData?.data?.cluster_analysis}
            resetFlag={resetFlag}
            filteredStartDate={startDate}
            filteredEndDate={endDate}
            channel={topicPreviewData?.channel}
            formatValue={formatValue}
          />
        );
      case 'customAnalysis':
        return (
          <CustomAnalysisTab
            job_id={job_id}
            handleTabClick={(data) => {
              handleTabClick(data);
            }}
            preview_uuid={topicPreviewData?.preview_uuid}
            onUpdateSearchQuery={updateSearchQuery}
            channel={topicPreviewData?.channel}
          />
        );
      case 'reviewsTab':
        return (
          <ReviewsTab
            resetFlag={resetFlag}
            min={startDate}
            max={endDate}
            startDate={startDate}
            search_type={topicPreviewData?.search_type || ''}
            endDate={endDate || endDate}
            preview_uuid={topicPreviewData?.preview_uuid}
            job_id={topicPreviewData?.job_id}
            filteredReviews={filteredData?.data?.overview_tab}
            channel={topicPreviewData?.channel}
            formatValue={formatValue}
          />
        );
      default:
        return null;
    }
  };
  const handleClear = () => {
    clearFilters();
    
    // dispatch(setPopUpActive(false))
  };
  const handleRedirectNexus = () => {
    
    navigate('/homepage/agents_home');

  }
  const handleCreatedTopic = () => {
    let newData = {
      ...topicPreviewData?.inputData,
      category:'topic'
    }
    dispatch(createNewTopic(newData))
      .then((res) => {
        dispatch(activeTopicList());
        if (res.payload?.data?.job_id) {
          dispatch(fetchCreatedTopic(res.payload?.data?.job_id)).then((res) => {
            // fetchedData = res?.payload?.data?.data;
          });

          navigate('/topic/job_' + res?.payload?.data?.job_id);
        } else {
          // navigate('/topic/home');
        }
      })
      .catch((err) => console.log(err));
  };

  const formatValue =
    personalDetailsData?.app_preference?.date_format === 'dd/mm/yyyy'
      ? 'dd/MM/yyyy'
      : personalDetailsData?.app_preference?.date_format === 'mm/dd/yyyy'
      ? 'MM/dd/yyyy'
      : personalDetailsData?.app_preference?.date_format === 'yyyy/mm/dd'
      ? 'yyyy/MM/dd'
      : 'dd/MM/yyyy';

  return (
    <Wrapper>
      {shareOption && (
        <GenerateAnalysis
          search_type={
            topicPreviewData?.search_type ||
            topicPreviewData?.youtube_search_type ||
            ''
          }
          obj_tabs={obj_tabs}
          open={shareOption}
          onClose={() => {
            setShareOption(false)
            
                dispatch(setPopUpActive(false))
          }}
          moduleType={
            topicPreviewData?.channel == 'news'
              ? 'News'
              : topicPreviewData?.channel == 'facebook'
              ? 'Facebook'
              : topicPreviewData?.channel == 'instagram'
              ? 'Instagram'
              : topicPreviewData?.channel == 'youtube'
              ? 'YouTube'
              : 'Twitter'
          }
          title={topicPreviewData?.title}
          job_id={job_id}
          reportData={fetchedData}
          topicPreviewData={topicPreviewData}
        />
      )}
      {filterFlag && (
        <FilterPopup
          handleClosePopup={handleClosePopup}
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
          filterOption={filterOption}
          handleFilterChange={handleFilterChange}
          openDropdown={openDropdown}
          setOpenDropdown={setOpenDropdown}
          view={view}
          setView={setView}
          handleCancel={handleCancel}
          handleApply={handleApply}
          handleClear={handleClear}
        />
      )}
      {
        loader ? <LoaderDiv >
        <Lottie
          data-testid='loader'
          animationData={Loader}
          loop={true}
          width='100px'
          height='100px'
        />
      </LoaderDiv> : 
        <>
        <button
        onClick={() => navigate('/topic/home')}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: '400',
          color: '#000',
          padding: '20px 0 0 24px',
          marginBottom: '-24px',
        }}
      >
        ← Back
      </button>
        <ReportHeaderFile
        job_id={job_id}
        topicPreviewData={topicPreviewData}
        handleCreatedTopic={handleCreatedTopic}
        handleRedirectNexus={handleRedirectNexus}
        onEdit={() => navigate('/topic/create', {
          state: {
            editData: {
              topic_title: topicPreviewData?.title,
              channel_name: topicPreviewData?.channel,
              description: topicPreviewData?.description,
              keywords_string: topicPreviewData?.inputData?.keywords_string,
              queryArrays: topicPreviewData?.inputData?.queryArrays || null,
              languages: topicPreviewData?.inputData?.languages,
              exclusions_string: topicPreviewData?.inputData?.exclusions_string,
              location_origin: topicPreviewData?.inputData?.location_origin,
              location_origin_radius: topicPreviewData?.inputData?.location_origin_radius,
              only_posts_with_media: topicPreviewData?.inputData?.only_posts_with_media,
              fetch_reposts: topicPreviewData?.inputData?.fetch_reposts,
              only_posts_from_verified_users: topicPreviewData?.inputData?.only_posts_from_verified_users,
              preview_uuid: topicPreviewData?.preview_uuid,
            }
          }
        })}
      />
      
      <FilterWithDate
        job_id={job_id}
        startDate={startDate}
        initialStartDate={startDate}
        dateHandler={dateHandler}
        formatValue={formatValue}
        endDate={endDate}
        initialEndDate={endDate}
        showSave={showSave}
        dateSubmit={dateSubmit}
        handleReset={handleReset}
        handleFilter={handleFilter}
        handleShareClick={handleShareClick}
        shareOption={shareOption}
      />
      <TabHeadingComp job_id={job_id} activeTab={activeTab} handleTabClick={handleTabClick} />
      <div style={{ width: '98%' }}>{renderTabContent()}</div>
        </>
        
      }
    </Wrapper>
  );
};

export default ActiveTopic;
